import React from 'react';
import PropTypes from 'prop-types';

import { Trans } from 'react-i18next';
import Styles from '../../../styles/minisite/minisite.module.css';
import { Form, Select, TooltipHelp, ToggleLabel } from '@weezevent/nacre';
import AddFavicon from '../upload/addFavicon';
import AddSocial from '../upload/addSocial';
import { LANGUAGES } from '../../../components/translations/translationModal';

export default function OtherOptions({ organization, event, formMinisite, handleChange, handleDelete, hasTranslationCapability }) {
    /*    const [showCookies, setShowCookies] = React.useState(false);
    const toggleCookies = React.useCallback(
        (ev, { checked }) => {
            handleChange('cookies', checked);
            setShowCookies(checked);
        },
        [setShowCookies, handleChange]
    );*/

    // old feature to hide or show the blur background
    // const [hideBackground, setHideBackground] = React.useState(formMinisite['background_hide']);
    // const toggleHideBackground = React.useCallback(
    //     (ev, { checked }) => {
    //         handleChange('background_hide', checked);
    //         setHideBackground(!hideBackground);
    //     },
    //     [handleChange, hideBackground]
    // );

    const setFavicon = React.useCallback(
        image => {
            handleChange('favicon', image);
        },
        [handleChange]
    );

    const removeFavicon = React.useCallback(() => {
        handleDelete('favicon');
    }, [handleDelete]);

    const setSocialImg = React.useCallback(
        (image, meta) => {
            handleChange('social_img', { image: image, ...meta });
        },
        [handleChange]
    );

    const removeSocialImg = React.useCallback(() => {
        handleDelete('social_img');
    }, [handleDelete]);

    const languageOptions = React.useMemo(() => {
        return event.languages.map(lang => {
            if (lang === 'it') {
                lang = 'it-it';
            }
            return {
                text: LANGUAGES[lang.toLowerCase()],
                value: lang
            };
        });
    }, [event]);

    const handleToggleLanguage = React.useCallback(
        (e, { checked }) => {
            if (!checked) {
                return handleDelete('language_dropdown');
            }
            handleChange('language_dropdown', checked);
        },
        [handleChange, handleDelete]
    );

    return (
        <Form>
            <div className={Styles['options-subtitle']}>
                <Trans i18nKey="ticket.event.minisite.other_options.title" />
            </div>
            {/* <Form.Field>
                <ToggleLabel
                    inlinePosition="left"
                    label={
                        <div className={Styles['options-title-toggle']}>
                            <Trans i18nKey="ticket.event.minisite.other_options.hide_banner" />
                            <TooltipHelp mini triggerOnHover title={<Trans i18nKey="ticket.event.minisite.other_options.hide_banner_text" />} />
                        </div>
                    }
                    onChange={toggleHideBackground}
                    value={formMinisite.background_hide}
                    checked={hideBackground}
                />
            </Form.Field> */}
            <Form.Field>
                <div className={Styles['options-title']}>
                    <Trans i18nKey="ticket.event.minisite.other_options.image" />
                    <TooltipHelp mini triggerOnHover title={<Trans i18nKey="ticket.event.minisite.other_options.image_text" />} />
                </div>
                <AddSocial organization={organization} event={event} removeSocial={removeSocialImg} onUpload={setSocialImg} image={formMinisite.social_img || null} />
            </Form.Field>
            <Form.Field>
                <div className={Styles['options-title']}>
                    <Trans i18nKey="ticket.event.minisite.other_options.favicon" />
                    <TooltipHelp mini triggerOnHover title={<Trans i18nKey="ticket.event.minisite.other_options.favicon_text" />} />
                </div>
                <AddFavicon
                    organization={organization}
                    url={formMinisite.domain + '/' + formMinisite.slug}
                    removeFavicon={removeFavicon}
                    onUpload={setFavicon}
                    image={formMinisite.favicon || null}
                    maxSize={5242880}
                />
            </Form.Field>
            <Form.Field>
                <div className={Styles['options-title']}>
                    <Trans i18nKey="ticket.event.minisite.other_options.language" />
                    <TooltipHelp mini triggerOnHover title={<Trans i18nKey="ticket.event.minisite.other_options.language_text" />} />
                </div>
                <Select className={Styles['select-language']} value={formMinisite['language']} options={languageOptions} onChange={value => handleChange('language', value)} />
            </Form.Field>

            {hasTranslationCapability && (
                <Form.Field>
                    <ToggleLabel
                        inlinePosition="left"
                        label={
                            <div className={Styles['options-title-toggle']}>
                                <Trans i18nKey="ticket.event.minisite.other_options.language_switch" />
                            </div>
                        }
                        onChange={handleToggleLanguage}
                        checked={Boolean(formMinisite.language_dropdown)}
                    />
                </Form.Field>
            )}

            {/*<Form.Field>
                <div className={Styles['options-title']}>
                    <Trans i18nKey="ticket.event.minisite.other_options.cookies" />
                </div>
                <div className={Styles['options-subtitle']}>
                    <Trans i18nKey="ticket.event.minisite.other_options.cookies_text" />
                </div>
                <Toggle
                    onChange={toggleCookies}
                    checked={showCookies}
                    value={formMinisite['cookies']}
                    activeLabel={t('ticket.common.cta.yes')}
                    inactiveLabel={t('ticket.common.cta.no')}
                />
            </Form.Field>*/}
        </Form>
    );
}
OtherOptions.propTypes = {
    organization: PropTypes.object.isRequired,
    formMinisite: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired
};
